import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { RootState } from 'store';

import type { AreaStatus } from 'types/spot';

type State = {
  isInitialize: boolean; // Suspenseと連動させるためのフラグ
  area: number;
  areaStatus: AreaStatus | null;
};

const initialState: State = {
  area: 0,
  isInitialize: false,
  areaStatus: null,
};

const baseUrl = process.env.REACT_APP_API_ENDPOINT || '';

// RTK Queryの設定
export const clearCardDataApi = createApi({
  reducerPath: 'clearCardDataApi',
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState }) => {
      // ここにカスタムヘッダーを追加します
      // 現在の状態にアクセスします
      const state = getState() as RootState;
      // 状態からユーザートークンを取得します
      const userToken = state.liffUser.userToken;
      headers.set('Content-Type', 'application/json');
      headers.set('Authorization', `Bearer ${userToken}`);
      return headers;
    },
  }),
  tagTypes: ['ClearCard'],
  endpoints: builder => ({
    postClearCardData: builder.mutation<AreaStatus, { area: number }>({
      query: ({ area }) => ({
        url: `/clear-card?area=${area}`,
        method: 'POST',
      }),
      invalidatesTags: ['ClearCard'],
    }),
  }),
});

// エンドポイント毎にカスタムhooksが作成される
export const { usePostClearCardDataMutation } = clearCardDataApi;

const clearCard = createSlice({
  name: 'clearCard',

  initialState,

  reducers: {
    updateArea: (state, action: PayloadAction<number>) => {
      state.area = action.payload;
    },
  },

  extraReducers: builder => {
    // POST後に状態を取得
    builder.addMatcher(
      clearCardDataApi.endpoints.postClearCardData.matchFulfilled,
      (state, action: PayloadAction<AreaStatus>) => {
        console.log('POST clear-card fulfilled');

        const areaStatus = action.payload;

        return {
          ...state,
          areaStatus,
          isInitialize: true,
        };
      }
    );
    // POST失敗
    builder.addMatcher(clearCardDataApi.endpoints.postClearCardData.matchRejected, state => {
      console.error('POST clear-card rejected');
    });
  },
});

// Action Creators
export const { updateArea } = clearCard.actions;

// Reducer
export default clearCard.reducer;
